import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ThridPartySignatureComponent } from './third-party-signature.component';

const routes: Routes = [{ path: 'logalty-signature-thirdParty/:code', component: ThridPartySignatureComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LogaltySignatureEkipRoutingModule {}
